module.exports = __webpack_public_path__ + "img/slider-moc-2_en.b077d86b.png";